
import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import {Table, Divider, Pagination, Input } from "antd";
import queryString from 'query-string'
import CreateReport from './eachRepoert';
import prettysize from '../../../../../src/utils';
import "./transferCostDetail.scss";
class TransferCostDetail extends Component{
    constructor(props) {
        super(props)

    }

    componentDidMount() {

    }


    updateSearch(event){
        this.setState({search: event.target.value.substr(0, 20)});
    }

    render(){

        let directions = new Map() 
        directions.set(1, "AWS to Wasabi")
        directions.set(2, "Wasabi to Wasabi")
        directions.set(4, "Azure to Wasabi")
        directions.set(8, "S3 Generic to Wasabi")
        directions.set(16, "Google to Wasabi")


        const columns = [

            {
              title: 'Direction',
              dataIndex: 'direction',
              key: 'direction',
              width: 120,
            },
            {
              title: 'Source Region',
              dataIndex: 'sourceRegion',
              key: 'sourceRegion',
              width: 130,
            },
            {
              title: 'Destination Region',
              dataIndex: 'destinationRegion',
              key: 'destinationRegion',
              width: 130,
            },
            {
                title: 'Transferred Size',
                dataIndex: 'transferredSize',
                key: 'transferredSize',
                width: 130,
            },
            {
              title: 'Total Cost',
              dataIndex: 'cost',
              key: 'cost',
              width: 120,
            }

          ];

          
        let data = this?.props?.listData?.map((t,index) => {
            return {
                key: index,
                username: t.username,
                direction: directions.get(t.source),
                sourceRegion: t.sourceRegion,
                destinationRegion: t.destinationRegion,
                totalSize: prettysize(t.totalSize),
                transferredSize: prettysize(t.transferredSize),
                cost: '$'+t.cost
            }
        })

        return(
            <div className="transferCost-wrapper">
                <div>
                <Table 
                    loading={this.props.loading}
                    columns={columns} 
                    dataSource={data} 
                    pagination={false}
                    scroll={{ y: 500 }} />

                </div>
            </div>
        )
    }
}

export default withRouter(
    connect(
    )(TransferCostDetail)
  );